var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "bairun-absolute-container bairun-oil-day-check" },
    [
      _c("el-header", { staticClass: "bairun-header" }, [
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { attrs: { inline: true } },
              [
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "mobile",
                        rawName: "v-mobile",
                        value: true,
                        expression: "true"
                      }
                    ],
                    attrs: { label: "" }
                  },
                  [
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "right-end", trigger: "click" },
                        model: {
                          value: _vm.showSelSeller,
                          callback: function($$v) {
                            _vm.showSelSeller = $$v
                          },
                          expression: "showSelSeller"
                        }
                      },
                      [
                        _vm.asyncStations.length > 1
                          ? _c(
                              "el-radio-group",
                              {
                                staticClass: "bairun-search-sellers",
                                attrs: { size: "mini" },
                                on: {
                                  change: function() {
                                    _vm.showSelSeller = false
                                  }
                                },
                                model: {
                                  value: _vm.searchInfo.stationId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchInfo, "stationId", $$v)
                                  },
                                  expression: "searchInfo.stationId"
                                }
                              },
                              [
                                _c(
                                  "el-radio",
                                  { attrs: { label: 0, border: "" } },
                                  [_vm._v("总")]
                                ),
                                _vm._l(_vm.asyncStations, function(item) {
                                  return _c(
                                    "el-radio",
                                    { attrs: { label: item.ID, border: "" } },
                                    [_vm._v(_vm._s(item.statAbbr))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("getSellerShortName")(
                                  _vm.searchInfo.stationId
                                )
                              )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "mobile",
                        rawName: "v-mobile",
                        value: false,
                        expression: "false"
                      }
                    ],
                    attrs: { label: "油站" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "选择油站" },
                        model: {
                          value: _vm.searchInfo.stationId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "stationId", $$v)
                          },
                          expression: "searchInfo.stationId"
                        }
                      },
                      _vm._l(_vm.asyncStations, function(item) {
                        return _c("el-option", {
                          key: item.ID,
                          attrs: { label: item.stationName, value: item.ID }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "油品" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择"
                        },
                        model: {
                          value: _vm.searchInfo.oilCode,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "oilCode", $$v)
                          },
                          expression: "searchInfo.oilCode"
                        }
                      },
                      _vm._l(_vm.oilCodeDict, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "月份" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "month",
                        format: "yyyy-MM",
                        "value-format": "yyyy-MM-dd 00:00:00",
                        placeholder: "月份选择",
                        clearable: false
                      },
                      on: { change: _vm.onMonthChange },
                      model: {
                        value: _vm.searchInfo.month,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "month", $$v)
                        },
                        expression: "searchInfo.month"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "日期" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd 00:00:00",
                        placeholder: "日期选择",
                        clearable: false,
                        "picker-options": _vm.startTimePickerOptions
                      },
                      model: {
                        value: _vm.searchInfo.startDate,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "startDate", $$v)
                        },
                        expression: "searchInfo.startDate"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd 23:59:59",
                        placeholder: "日期选择",
                        clearable: false,
                        "picker-options": _vm.endTimePickerOptions
                      },
                      model: {
                        value: _vm.searchInfo.endDate,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "endDate", $$v)
                        },
                        expression: "searchInfo.endDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("查询")]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onRecompute }
                      },
                      [_vm._v("重新计算")]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-main",
        { staticClass: "bairun-main" },
        [
          _c(
            "div",
            { staticClass: "bairun-padding" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    stripe: "",
                    border: "",
                    "span-method": _vm.tableCellMerge
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "日期" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.dailyDate))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "油品" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v("#" + _vm._s(scope.row.oilCode))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "上日库存(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !scope.row.editAble
                              ? _c("div", [
                                  _vm._v(_vm._s(scope.row.totalLastDailyLiters))
                                ])
                              : _c("el-input-number", {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请输入",
                                    min: 0,
                                    controls: false
                                  },
                                  model: {
                                    value: scope.row.totalLastDailyLiters,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "totalLastDailyLiters",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.totalLastDailyLiters"
                                  }
                                })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "进油(吨)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalGiveInTon))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "进油(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalGiveInLiters))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "调灌(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalAdjustLiters))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销售数(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.totalOilSales))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "账面库存(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalCurrentDailyLiters))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "液位仪库存(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalSequenceLiters))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手工实测库存(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.totalTankRealLiters))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "液位仪盈亏(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.totalSequenceLossLiters < 0
                              ? _c("div", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(scope.row.totalSequenceLossLiters) +
                                      "  ↓"
                                  )
                                ])
                              : _vm._e(),
                            scope.row.totalSequenceLossLiters > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#67C23A" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.totalSequenceLossLiters
                                      ) + "  ↑"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手工盈亏(升)" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.totalTankRealLossLiters < 0
                              ? _c("div", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(scope.row.totalTankRealLossLiters) +
                                      "  ↓"
                                  )
                                ])
                              : _vm._e(),
                            scope.row.totalTankRealLossLiters > 0
                              ? _c(
                                  "div",
                                  { staticStyle: { color: "#67C23A" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.totalTankRealLossLiters
                                      ) + "  ↑"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "130px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !scope.row.editAble
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "table-button",
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onUpdate(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("变更")]
                                )
                              : _vm._e(),
                            scope.row.editAble
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "table-button",
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onSave(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("保存")]
                                )
                              : _vm._e(),
                            scope.row.editAble
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "table-button",
                                    attrs: { size: "small" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onCancel(scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v("取消")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                directives: [
                  {
                    name: "mobile",
                    rawName: "v-mobile",
                    value: true,
                    expression: "true"
                  }
                ],
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": true,
                  "pager-count": 5,
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "size-change": _vm.handleSizeChange
                }
              }),
              _c("el-pagination", {
                directives: [
                  {
                    name: "mobile",
                    rawName: "v-mobile",
                    value: false,
                    expression: "false"
                  }
                ],
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                "before-close": _vm.closeDialog,
                visible: _vm.dialogVisible,
                title: "重新计算库存溢损"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "formData",
                  attrs: {
                    model: _vm.formData,
                    "label-position": "right",
                    "label-width": "120px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "油站:" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "选择油站" },
                          model: {
                            value: _vm.formData.stationId,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "stationId", $$v)
                            },
                            expression: "formData.stationId"
                          }
                        },
                        _vm._l(_vm.asyncStations, function(item) {
                          return _c("el-option", {
                            key: item.ID,
                            attrs: { label: item.stationName, value: item.ID }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "开始时间:" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyyMMdd",
                          placeholder: "日期选择",
                          clearable: false
                        },
                        model: {
                          value: _vm.formData.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "startDate", $$v)
                          },
                          expression: "formData.startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "结束时间:" }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyyMMdd",
                          placeholder: "日期选择",
                          clearable: false
                        },
                        model: {
                          value: _vm.formData.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "endDate", $$v)
                          },
                          expression: "formData.endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("el-button", { on: { click: _vm.closeDialog } }, [
                    _vm._v("取 消")
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.enterDialog }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }